var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"announcement-backdrop"},[_c('div',{staticClass:"announcement-wrapper"},[_c('div',{staticClass:"announcement-inner"},[_c('div',{attrs:{"id":"announcement-close-btn"},on:{"click":_vm.handleClose}}),_c('div',{staticClass:"announcement-content"},[_vm._t("default")],2)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }